<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Card,
        Heading,
        Paragraph,
    } from '@smatch/cassiopeia-web-components';

    // LAYOUTS
    import LayoutLanding from 'src/app/library/layouts/layout-landing/LayoutLanding.svelte';

</script>

<LayoutLanding>

    <div class = 's8-wrapper'>
        <Heading size='lg'>Thank you for getting in touch.</Heading>

        <div class = 's8-card'>
            <Card color='primary' style='ghost'>
                <Heading size = 'sm'>What happens next?</Heading>

                <Paragraph color = 'success'>
                    Relax! This is where we take over.
                    Our team will reach out to you shortly, you can now close this page if you want to.
                </Paragraph>
            </Card>
        </div>
    </div>

</LayoutLanding>

<style lang='postcss'>
    div.s8-wrapper {
        justify-items: center;
    }

    div.s8-card {
        max-width: 450px;
    }
</style>